export default "__VITE_ASSET__Deaeujpx__"